import React, { useEffect, FC } from 'react';
import { addLinkQueryParams } from '../../../../server/utils/addLinkQueryParams';
import { CategoryData } from '../../../../shared/types';
import { categoryViewed } from '../../../../utils/bi';
import ArticleList from './ArticleList';

interface ArticleCategoryProps {
  data: CategoryData;
}

const ArticleCategory: FC<ArticleCategoryProps> = ({ data }) => {
  const {
    category: { heading, description },
    articles,
  } = data;

  useEffect(() => categoryViewed({ category: { name: heading } }), [heading]);

  return (
    <div className="category-page">
      <h1>{heading}</h1>
      <div className="rich-text" dangerouslySetInnerHTML={{ __html: addLinkQueryParams(description) }} />
      <ArticleList articles={articles || []} />
    </div>
  );
};

export default ArticleCategory;
